import { Component, OnInit, inject, DestroyRef } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { FiltersService } from 'src/app/core/services/filters/filters.service';
import { FilterUtilService } from 'src/app/core/services/uitls/filter-utilizer/filter-util.service';
import { SpecialtyFormComponent } from '../../components/specialty-form/specialty-form.component';
import { SpecialtiesService } from '../../services/specialties/specialties.service';
import { Specialty } from '../../models/specialty.model';
import { AlertBoxComponent } from 'src/app/shared/components/alert-box/alert-box.component';

@Component({
    selector: 'app-specialties-list',
    templateUrl: './specialties-list.component.html',
    styleUrls: ['./specialties-list.component.scss'],
    standalone: false
})
export class SpecialtiesListComponent implements OnInit {
  specialties: Specialty[] = [];
  spinner = false;
  searchValue = '';
  page_size = 20;
  config = {
    id: 'specialtiesListPagination',
    itemsPerPage: this.page_size,
    currentPage: 1,
    totalItems: 0,
  };
  filterParamsUrl: Record<string, any> = {};
  filterDataInit = {};
  filterPage = 'SPECIALIZATIONS';
  spinnerKey = 'spinner';
  filterData: any;

  private destroyRef = inject(DestroyRef);

  constructor(
    private specialtiesService: SpecialtiesService,
    private filter: FiltersService,
    private filterUtil: FilterUtilService,
    private dialog: MatDialog,
  ) {}

  ngOnInit(): void {
    this.getFilterData();
    this.filter.changeSelectedFilter(this.filterDataInit);
    this.filterUtil.applySelectedFilter(this, this.loadData, this.spinnerKey);
  }

  getFilterData(): void {
    this.filter.getFiltersData({ filter_page: this.filterPage }).pipe(takeUntilDestroyed(this.destroyRef)).subscribe({
      next: (data) => { this.filterData = data; },
      error: () => { /* Filter data loading failed silently */ },
    });
  }

  filterFormValues(event: any): void {
    this.spinner = true;
    this.filterParamsUrl = event.filterParamsUrl;
    this.resetPagination();
    this.loadData();
  }

  loadData(): void {
    this.spinner = true;
    const payload: Record<string, any> = {
      page: this.config.currentPage,
      page_size: this.config.itemsPerPage,
      ...this.filterParamsUrl,
    };
    if (this.searchValue) {
      payload['search'] = this.searchValue;
    }
    this.specialtiesService.getSpecialties(payload).pipe(takeUntilDestroyed(this.destroyRef)).subscribe({
      next: (response) => {
        this.specialties = response.data ?? [];
        this.config.totalItems = response.count ?? this.specialties.length;
        this.spinner = false;
      },
      error: () => {
        this.specialties = [];
        this.config.totalItems = 0;
        this.spinner = false;
      },
    });
  }

  quickSearch(value: string): void {
    this.searchValue = value ?? '';
    this.resetPagination();
    this.loadData();
  }

  private resetPagination(): void {
    this.config.currentPage = 1;
    this.config.itemsPerPage = this.page_size;
  }

  pageChanged(event: any): void {
    this.config.currentPage = event.currentPage ?? event;
    this.loadData();
  }

  pageSizeChanged(size: number): void {
    this.config.itemsPerPage = size;
    this.config.currentPage = 1;
    this.loadData();
  }

  addSpecialty(): void {
    const dialogRef = this.dialog.open(SpecialtyFormComponent, {
      width: '844px',
      maxWidth: '95vw',
      data: {},
    });

    dialogRef.afterClosed().pipe(takeUntilDestroyed(this.destroyRef)).subscribe((result: Specialty) => {
      if (!result) return;
      this.resetPagination();
      this.loadData();
      this.showAlertDialog(true, 'تم اضافه التخصص بنجاح');
    });
  }

  editSpecialty(item: Specialty): void {
    const dialogRef = this.dialog.open(SpecialtyFormComponent, {
      width: '844px',
      maxWidth: '95vw',
      data: { ...item },
    });

    dialogRef.afterClosed().pipe(takeUntilDestroyed(this.destroyRef)).subscribe((result: Specialty) => {
      if (!result) return;
      this.loadData();
      this.showAlertDialog(true, 'تم تعديل التخصص بنجاح');
    });
  }

  private showAlertDialog(success: boolean, message: string): void {
    this.dialog.open(AlertBoxComponent, {
      data: {
        imgSuccess: success,
        message,
        button: 'تم',
      },
    });
  }
}
